<template>
  <div>
    <el-dialog
      :visible.sync="info.show"
      :modal="false"
      append-to-body
      :close-on-click-modal="false"
      class="thisblack"
      custom-class="participantSetting"
      width="800px"
    >
      <el-tabs v-model="tabVal" tab-position="left">
        <el-tab-pane
          v-for="item in tabArray"
          :key="item.label"
          :name="item.name"
          :label="$t(`audioSettings.${item.label}`)"
        >
          <participantSettingHead @visibleChange="visibleChange"/>
          <component
            :is="item.content"
            :audioInfo="audioInfo"
            :info="info"
          ></component>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AudioFeedback from './audioFeedback.vue';
import participantSettingHead from '@/components/participantSettingHead.vue'
import participantAudioSetting from '@/components/participantAudioSetting.vue'

export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    audioInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      tabVal: '1',
      tabArray: [
        {
          name: '1',
          label: 'title',
          content: participantAudioSetting
        },
        {
          name: '2',
          label: 'audioFeedback',
          content: AudioFeedback
        }
      ]
    }
  },
  components: {
    AudioFeedback,
    participantSettingHead,
    participantAudioSetting
  },
  computed: {
    ...mapState({
      State: state => state
    })
  },
  methods: {
    visibleChange () {
      this.info.show = false
    }
  }
}
</script>
<style lang="less" scoped>

</style>
